<footer
  class="sm:bg-none  sm:bg-none fixed bottom-0 left-[78px] w-[calc(100%-78px)] transition-all duration-500 ease-in-out z-20 p-2 pl-5 pr-14 md:flex md:items-center md:justify-between "
  [ngClass]="{ 'foot-open': sidebarService.isOpen()}"
>
  <span class="text-secondary-main-color sm:text-center copyright text-[10px]"
    >© {{ currentYear }} <a href="#" class="hover:underline">Tamiin™</a> All
    Rights Reserved.
  </span>
  <!-- <img
    class="w-[30px]"
    src="/assets/images/tamiinsymbollogo.png"
    alt="Tamin logo"
  /> -->
  <ul
    class="flex flex-wrap items-center mt-3 text-[10px] font-small text-secondary-main-color sm:mt-0 copyright"
  >
    <li>
      <a href="#" class="hover:underline me-4 md:me-6">About</a>
    </li>
    <li>
      <a href="#" class="hover:underline me-4 md:me-6">Privacy Policy</a>
    </li>
    <li>
      <a href="#" class="hover:underline me-4 md:me-6">Terms of Use</a>
    </li>
    <li>
      <a href="#" class="hover:underline">Docs</a>
    </li>
  </ul>
</footer>
